var global = require('../internals/global');

module.exports = global.Promise;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/native-promise-constructor.js